import React from 'react';
import { OrderItem } from '../driverActiveDeliveriesTypes';
import styles from './OrderItemsTable.module.css';

interface OrderItemsTableProps {
  items: OrderItem[];
}

export const OrderItemsTable: React.FC<OrderItemsTableProps> = ({ items }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Order Items</h3>
      <div className={styles.list}>
        {items.map((item) => (
          <div key={item.id} className={styles.row}>
            <span className={styles.name}>{item.name}</span>
            <span className={styles.qty}>{item.quantity}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
